import { Observable } from 'rxjs';
import { ISelectOption } from 'app/interfaces/ISelectOption';
import { MatDialogRef } from '@angular/material/dialog';

export const fullScreenMarginLeft = '48px';
export const fullScreenWidth = '98%';
export const placeholderForTitle = 'Test'; // Todo: should be removed after all title has been provided

interface IDialogPosition {
    top: string;
    left: string;
}

interface IDialogSize {
    height: string;
    width: string;
}

export interface IJqueryUIPosition {
    top: number;
    left: number;
}

export interface IJqueryUISize {
    height: number;
    width: number;
}

export interface IDropdownConfig<T> {
    dropdownOptions: Observable<Array<ISelectOption<T>>>;
    dropdownLabel: string;
    description?: string;
    selectedOptionLabel?: string;
    selectedValue?: T;
}

export function positionJqueryUIToDialog(position: IJqueryUIPosition): IDialogPosition {
    return {
        top: position.top.toString() + 'px',
        left: position.left.toString() + 'px'
    };
}

export function sizeJqueryUIToDialog(size: IJqueryUISize): IDialogSize {
    return {
        height: size.height.toString() + 'px',
        width: size.width.toString() + 'px'
    };
}

export function getCenteredPosition(currentSize: IJqueryUISize): IJqueryUIPosition {
    return {
        top: (window.innerHeight - currentSize.height) / 2,
        left: (window.innerWidth - currentSize.width) / 2
    };
}

export function updateDialogSizeAndPosition(dialogRef: MatDialogRef<unknown>, options: { width: string, height: string, top: string, left: string }): void {
    dialogRef.updateSize(options.width, options.height);
    dialogRef.updatePosition({
        top: options.top,
        left: options.left
    });
}
